import { useParams } from 'react-router-dom';
import SPKCandidateList from '$components/SPKCandidateList/SPKCandidateList';
import { useGetSharedCandidatesRosterDataQuery } from '$store/modules/candidates';
import Spinner from '../../Spinner/Spinner';
import classes from '../SharePosition/SharePosition.module.css';

const ShareCandidates = () => {
  const { shareCandidatesIds } = useParams();

  const {
    data: sharedRosterData,
    isLoading,
    error,
  } = useGetSharedCandidatesRosterDataQuery({
    sharedRosterId: shareCandidatesIds as string,
  });

  return (
    <div data-testid="shareCandidatesPage" className="pb-8 font-mulish">
      <div className="flex flex-col gap-4">
        {isLoading && (
          <div className={classes.spinner}>
            <Spinner height="100%" width="100%" />
          </div>
        )}
        {error && <div className="m-auto">Invalid Request</div>}

        {!isLoading && sharedRosterData && (
          <>
            <div className="flex items-center relative py-4">
              <span className="text-neutral-600 text-sm absolute text-nowrap -top-1 font-light">
                Matching Position
              </span>
              <div className="text-xl font-extrabold pr-4 text-nowrap">
                {sharedRosterData?.positionName}
              </div>
              <div className="border-b-2 w-full h-1" />
            </div>
            <SPKCandidateList
              candidates={sharedRosterData.candidates}
              shareCandidatesIds={shareCandidatesIds as string}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ShareCandidates;
